<template>
  <v-dialog v-model="dialog" max-width="820" persistent>
    <template v-slot:activator="{ on }">
      <!-- v-btn v-on="on">
        Bjud in via SMS
      </v-btn -->
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-message-alert</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Bjud in via SMS</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="color-a">Bjud in deltagare via SMS</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <p>
              Börja med att lägga till de mobilnummer du vill skicka en inbjudan
              till, det går även att ladda upp en csv fil med mobilnummer
            </p>
            <v-row align="center">
              <v-col style="padding-bottom:0px; padding-top:0px;">
                <v-text-field
                  v-model="addInviteesField"
                  prepend-icon="mdi-cellphone"
                  label="Mobilnummer"
                  hint="+46712345678 / 0712345678"
                  :error="!isValid(addInviteesField)"
                ></v-text-field>
              </v-col>
              <v-col cols="4" style="padding:10px;">
                <v-btn
                  small
                  color="white"
                  class="color-a"
                  dark
                  @click="addInvitee"
                >
                  Lägg till<v-icon small>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col style="padding-bottom:0px; padding-top:0px;">
                <v-file-input
                  accept=".csv"
                  v-model="file"
                  label="Välj fil"
                ></v-file-input>
              </v-col>
              <v-col cols="4" style="padding:10px;">
                <v-btn
                  small
                  color="white"
                  class="color-a"
                  dark
                  @click="uploadFile"
                >
                  Ladda upp
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-card class="col col-12">
              <v-card-title>
                Skicka inbjudan till: ({{ invitees.length }}st)</v-card-title
              >
              <v-card-text
                style="max-height: 250px;
    overflow-x: hidden;"
              >
                <v-row
                  v-for="(invitee, index) in invitees"
                  :key="index"
                  align="center"
                  style="border-bottom:1px solid #ccc;padding-bottom:4px;margin-bottom:4px;"
                >
                  <v-col style="padding-bottom:0px; padding-top:0px;">
                    {{ invitee.to }}
                  </v-col>
                  <v-btn
                    x-small
                    color="white"
                    class="color-a col col-3"
                    dark
                    @click="removeInvite(invitee.id)"
                  >
                    Ta bort
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="sendInvitees"
                  >Skicka inbjudan</v-btn
                >
              </v-card-actions>
            </v-card>
            <v-card
              class="col col-12"
              v-if="inviteesAlreadySent.length > 0"
              style="margin-top:20px"
            >
              <v-card-title> Inbjudna: </v-card-title>
              <v-card-text
                style="max-height: 250px;
    overflow-x: hidden;"
              >
                <v-row
                  v-for="(invitee, index) in inviteesAlreadySent"
                  :key="index"
                  align="center"
                  style="border-bottom:1px solid #ccc;padding-bottom:4px;margin-bottom:4px;"
                >
                  <v-col style="padding-bottom:0px; padding-top:0px;">
                    {{ invitee.to }}
                  </v-col>
                  <v-btn
                    x-small
                    color="white"
                    class="color-a col col-3"
                    dark
                    @click="sendAgain(invitee)"
                  >
                    Skicka igen
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Stäng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    meeting: Object
  },
  data() {
    return {
      dialog: false,
      addInviteesField: "",
      file: null
    };
  },
  computed: {
    allInviteesValid() {
      return this.invitees.filter(inv => !this.isValid(inv)).length === 0;
    },
    invitees() {
      return this.$store.getters["meetings/getInvitees"].filter(a => !a.send);
    },
    inviteesAlreadySent() {
      return this.$store.getters["meetings/getInvitees"].filter(a => a.send);
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    async create() {
      console.log(this.invitees);
      const success = await this.$store.dispatch("meetings/addInviteNumber", {
        meeting: this.meeting,
        organizationName: this.meeting.organizationName,
        invite: this.invitees.map(a => {
          if (/07\d{8}/gm.test(a)) {
            return a.replace(/^.{1}/g, "+46");
          } else {
            return a;
          }
        })
      });
      if (success) {
        this.close();
      }
    },
    isValid(invitee) {
      return /\+467\d{8}/gm.test(invitee) || /07\d{8}/gm.test(invitee);
    },
    async addInvitee() {
      if (this.isValid(this.addInviteesField)) {
        if (/07\d{8}/gm.test(this.addInviteesField)) {
          this.addInviteesField = this.addInviteesField.replace(
            /^.{1}/g,
            "+46"
          );
        }
        const success = await this.$store.dispatch("meetings/addInviteNumber", {
          meeting: this.meeting,
          organizationName: this.meeting.organizationName,
          invite: this.addInviteesField
        });
        if (success) {
          this.addInviteesField = "";
        }
      }
    },
    async removeInvite(id) {
      await this.$store.dispatch("meetings/removeInviteNumber", {
        meeting: this.meeting,
        invite: id
      });
    },
    async sendInvitees() {
      for (let invite of this.invitees) {
        console.log(invite);
        if (!invite.send) {
          await this.$store.dispatch("meetings/sendInviteMessages", {
            meeting: this.meeting,
            invite: invite
          });
        }
      }
    },
    async sendAgain(invite) {
      await this.$store.dispatch("meetings/resendInviteMessages", {
        meeting: this.meeting,
        id: invite.id
      });
    },
    async uploadFile() {
      await this.$store.dispatch("meetings/uploadInvites", {
        meetingId: this.meeting.id,
        file: this.file
      });
    }
  },
  async mounted() {
    await this.$store.dispatch(
      "meetings/inviteesListener",
      this.$route.params.meetingId
    );
  }
};
</script>

<style></style>
